import React from "react";

import { Card, CardContent } from "../../components/ui/card";
import InfoTooltip from "../../components/ui/InfoTooltip";
import { Label } from "../../components/ui/label";
import MultipleSelector from "../../components/ui/MultipleSelector";

import ListManager from "../../components/ListManager";

import { projectMetadataOptions } from "../../helpers/projectMetadataHelper";

const ProjectSystems = ({ properties, setProperties }) => {
  const updateProperties = async (field, value) => {
    const updatedProperties = {
      ...properties,
      [field]: value,
    };

    setProperties(updatedProperties);
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <div className="space-y-2">
          <h4 className="font-medium">
            <div className="flex items-center gap-2 relative">
              <Label>User Types</Label>

              <div className="relative group">
                <InfoTooltip text="Select the user types that will interact with your project. This helps identify risks specific to each user type." />
              </div>
            </div>
          </h4>

          <MultipleSelector
            creatable
            defaultOptions={
              projectMetadataOptions.userTypes.map((userType) => {
                return {
                  label: userType,
                  value: userType,
                };
              }) || []
            }
            value={
              properties.users.map((user) => {
                return {
                  label: user,
                  value: user,
                };
              }) || []
            }
            onChange={(value) =>
              updateProperties(
                "users",
                value.map((x) => x.value)
              )
            }
            placeholder={
              properties.users.length > 0
                ? "Create custom user type..."
                : "Select user types..."
            }
          />
        </div>

        <ListManager
          items={properties.systems.map((system) =>
            typeof system === "string" ? system : system.name
          )}
          onAdd={(system) =>
            updateProperties("systems", [
              ...properties.systems,
              {
                id: `sys_${Date.now()}_${Math.random()
                  .toString(36)
                  .substr(2, 9)}`,
                name: system,
                subsystems: [],
              },
            ])
          }
          onRemove={(index) =>
            updateProperties(
              "systems",
              properties.systems.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Systems/Sub-Systems</Label>

              <div className="relative group">
                <InfoTooltip text="Add systems and sub-systems that are part of your project." />
              </div>
            </div>
          }
          placeholder="Add system..."
        />

        <ListManager
          items={properties.operatingModes}
          onAdd={(mode) =>
            updateProperties("operatingModes", [
              ...properties.operatingModes,
              mode,
            ])
          }
          onRemove={(index) =>
            updateProperties(
              "operatingModes",
              properties.operatingModes.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Operating Modes</Label>

              <div className="relative group">
                <InfoTooltip text="Add operating modes that are part of your project. This helps identify risks specific to each mode." />
              </div>
            </div>
          }
          placeholder="Add operating mode..."
        />
        {/* TODO: Standards currently not doing anything. */}
        {/* <ListManager
          items={properties.standards}
          onAdd={(standard) =>
            updateProperties("standards", [...properties.standards, standard])
          }
          onRemove={(index) =>
            updateProperties(
              "standards",
              properties.standards.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Applicable Standards</Label>

              <div className="relative group">
                <InfoTooltip text="Optional - Add standards that apply to your project" />
              </div>
            </div>
          }
          placeholder="Add standard..."
        /> */}
      </CardContent>
    </Card>
  );
};

export default ProjectSystems;
